module.exports = __webpack_public_path__ + "img/reply-all-fill.88f9c1fd.svg";